import React from 'react';
import { motion } from 'framer-motion';
import { UtensilsCrossedIcon, ShoppingCartIcon, SaladIcon, SproutIcon, SmileIcon, HeartIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { benefits } from '../data/content';
const icons = [UtensilsCrossedIcon, ShoppingCartIcon, SaladIcon, SproutIcon, SmileIcon, HeartIcon];
export function Benefits() {
  return <section className="w-full bg-green-soft/40 py-16 sm:py-24" data-id="element-20" data-mp="3qsf9bwgjp82e">
      <div className="mx-auto max-w-6xl px-5" data-id="element-21" data-mp="3mpizov8zgmal">
        <SectionHeading eyebrow="Beneficios" title="Por eso creamos 250 recetas para viandas escolares" subtitle="Una guía diseñada específicamente para simplificar tu día a día." data-id="element-22" data-mp="3mor0zbk3a8g3" />

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-23" data-mp="3cu7js9lu9919">
          {benefits.map((b, i) => {
          const Icon = icons[i % icons.length];
          return <motion.div key={b.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.45,
            delay: i * 0.06
          }} className="group rounded-3xl border border-beige bg-white p-7 shadow-sm transition-all duration-200 hover:-translate-y-1 hover:shadow-lg" data-id="element-24" data-mp="1ayortwj5eem9" data-mpi={i}>
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-green-soft transition-colors group-hover:bg-yellow-soft" data-id="element-25" data-mp="liqo9tct9xcj">
                  <Icon className="h-7 w-7 text-green-brand" data-id="element-26" data-mp="qilgq1c8iuzp" />
                </div>
                <h3 className="mt-5 font-display text-xl font-bold text-green-deep" data-id="element-27" data-mp="brmd74q9awmz">
                  {b.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-[#5A6656]" data-id="element-28" data-mp="14gtkas3s0uju">
                  {b.body}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}